import { Link, Navigate, Route, Routes } from 'react-router-dom'

import { AdminLayout } from '@/components/layout/AdminLayout'
import { RequireAdmin } from '@/components/layout/RouteGuards'
import { Toaster } from '@/components/ui/Feedback'
import { LoginPage } from '@/features/auth/LoginPage'
import { LiveQueuePage } from '@/features/live/LiveQueuePage'
import { LiveSolvePage } from '@/features/live/LiveSolvePage'
import { OverviewPage } from '@/features/overview/OverviewPage'
import { PartnerDetailPage } from '@/features/partners/PartnerDetailPage'
import { PartnersPage } from '@/features/partners/PartnersPage'
import { UserDetailPage } from '@/features/users/UserDetailPage'
import { UsersPage } from '@/features/users/UsersPage'

export default function App() {
  return (
    <>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route element={<RequireAdmin />}>
          <Route element={<AdminLayout />}>
            <Route index element={<OverviewPage />} />
            <Route path="live" element={<LiveQueuePage />} />
            <Route path="live/:handoffId" element={<LiveSolvePage />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="users/:userId" element={<UserDetailPage />} />
            <Route path="partners" element={<PartnersPage />} />
            <Route path="partners/:partnerId" element={<PartnerDetailPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster />
    </>
  )
}

function NotFound() {
  return (
    <div className="flex flex-col items-center px-4 py-20 text-center">
      <p className="num rounded-pill bg-accent-soft px-3 py-1 text-[12px] font-medium text-ink-soft">404</p>
      <h1 className="mt-4 text-[22px] font-semibold tracking-[-0.02em] text-ink">Page not found</h1>
      <p className="mt-1 text-[14px] text-ink-muted">That link does not go anywhere.</p>
      <Link to="/" className="mt-6 inline-flex h-11 items-center rounded-field bg-ink px-5 text-[15px] font-medium text-oncolor hover:bg-ink/90">
        Back to the overview
      </Link>
    </div>
  )
}
